var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 353.2 337.6",
    style: {
      enableBackground: "new 0 0 353.2 337.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#192958;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BKGD",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 353.2,
    height: 337.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 14,
    cy: 168.5,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 77.1,
    cy: 168.5,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 51.3,
    cy: 209.8,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 96.6,
    cy: 227.8,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 99.4,
    cy: 276.8,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 51.3,
    cy: 127.1,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 45.5,
    cy: 72.8,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 96.6,
    cy: 108.7,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 98.4,
    cy: 61.7,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 145.9,
    cy: 72.8,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 207.1,
    cy: 72.8,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 253.3,
    cy: 61.1,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 256.5,
    cy: 109.7,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 301.9,
    cy: 127.1,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 301.9,
    cy: 209.8,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 256.5,
    cy: 227.9,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 308.1,
    cy: 264.2,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 207.1,
    cy: 264.2,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 145.9,
    cy: 264.2,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 45.1,
    cy: 264.2,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 253.3,
    cy: 276.8,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 176.3,
    cy: 301.5,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 226.7,
    cy: 323.6,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 126.6,
    cy: 323.6,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 276.5,
    cy: 168.5,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 339.2,
    cy: 168.5,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 308.1,
    cy: 72.8,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 176.3,
    cy: 35.5,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 126.2,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 226.8,
    cy: 14,
    r: 14
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearLogoWhite);
export default __webpack_public_path__ + "static/media/clear_logo_white.ea7d32c606eb3feb11f45b940b558d62.svg";
export { ForwardRef as ReactComponent };